
import * as util from 'util'

import * as big from '../big'
import * as int64 from '../int64'
import * as uuid from '../uuid'

import * as fbe from '../fbe'
import * as core from '../core'
import * as config from '../config'
import * as history from '../history'
import * as client from '../client'
import * as feed from '../feed'
import * as storage from '../storage'
import * as exposed from '../exposed'
import * as execution from '../execution'
import * as backup from '../backup'
import * as inner from '../inner'
import * as trade from '../trade'
import * as security from '../security'
import * as document from '../document'

const Big = big.Big // eslint-disable-line
const Int64 = int64.Int64 // eslint-disable-line
const UInt64 = int64.UInt64 // eslint-disable-line
const UUID = uuid.UUID // eslint-disable-line
import {ConfigUpdateResponse} from './ConfigUpdateResponse';
import {FieldModelConfigUpdateResponse} from './ConfigUpdateResponse';

/**
 * SwapsImportResponse struct
 */
class SwapsImportResponse extends ConfigUpdateResponse {
  /**
   * Initialize struct
   * @param {!ConfigUpdateResponse=} parent
   * @param {!Array=} groupsUpdated
   * @param {!Array=} symbolsUpdated
   * @constructor
   */
  constructor (parent = new ConfigUpdateResponse(), groupsUpdated = [], symbolsUpdated = []) {
    super()
    super.copy(parent)
    this.GroupsUpdated = groupsUpdated
    this.SymbolsUpdated = symbolsUpdated
  }

  /**
   * Copy struct (shallow copy)
   * @this {!SwapsImportResponse}
   * @param {!SwapsImportResponse} other Other struct
   * @returns {!SwapsImportResponse} This struct
   */
  copy (other) {
    super.copy(other)
    if (other.GroupsUpdated != null) {
      this.GroupsUpdated = []
      for (let item of other.GroupsUpdated) {
        if (item != null) {
          let tempItem
          tempItem = item
          this.GroupsUpdated.push(tempItem)
        } else {
          this.GroupsUpdated.push(null)
        }
      }
    } else {
      this.GroupsUpdated = null
    }
    if (other.SymbolsUpdated != null) {
      this.SymbolsUpdated = []
      for (let item of other.SymbolsUpdated) {
        if (item != null) {
          let tempItem
          tempItem = item
          this.SymbolsUpdated.push(tempItem)
        } else {
          this.SymbolsUpdated.push(null)
        }
      }
    } else {
      this.SymbolsUpdated = null
    }
    return this
  }

  /**
   * Clone struct (deep clone)
   * @this {!SwapsImportResponse}
   * @returns {!SwapsImportResponse} Cloned struct
   */
  clone () {
    // Serialize the struct to the FBE stream
    let writer = new SwapsImportResponseModel(new fbe.WriteBuffer())
    writer.serialize(this)

    // Deserialize the struct from the FBE stream
    let reader = new SwapsImportResponseModel(new fbe.ReadBuffer())
    reader.attachBuffer(writer.buffer)
    return reader.deserialize().value
  }

  /**
   * Is this struct equal to other one?
   * @this {!SwapsImportResponse}
   * @param {!SwapsImportResponse} other Other struct
   * @returns {boolean} Equal result
   */
  eq (other) {
    if (!(other instanceof SwapsImportResponse)) {
      throw new TypeError('Instance of SwapsImportResponse is required!')
    }
    // noinspection RedundantIfStatementJS
    if (!super.eq(other)) {
      return false
    }
    return true
  }

  /**
   * Convert struct to JSON
   * @this {!SwapsImportResponse}
   * @returns {!object} Struct value for JSON
   */
  toJSON () {
    let parent = super.toJSON()
    let current = {
      GroupsUpdated: ((this.GroupsUpdated != null) ? Array.from(this.GroupsUpdated, item => ((item != null) ? item : null)) : null),
      SymbolsUpdated: ((this.SymbolsUpdated != null) ? Array.from(this.SymbolsUpdated, item => ((item != null) ? item : null)) : null)
    }
    return { ...parent, ...current }
  }

  /**
   * Convert JSON to struct
   * @param {!string} json JSON string
   * @returns {!object} Struct value for JSON
   */
  static fromJSON (json) {
    return SwapsImportResponse.fromObject(JSON.parse(json))
  }

  /**
   * Create struct from object value
   * @param {!SwapsImportResponse} other Object value
   * @returns {!SwapsImportResponse} Created struct
   */
  static fromObject (other) {
    return new SwapsImportResponse().copy(other)
  }

  /**
   * Get the FBE type
   * @this {!SwapsImportResponse}
   * @returns {!number} FBE type
   */
  get fbeType () {
    return SwapsImportResponse.fbeType
  }

  /**
   * Get the FBE type (static)
   * @this {!SwapsImportResponse}
   * @returns {!number} FBE type
   */
  static get fbeType () {
    return 6121
  }
}

export { SwapsImportResponse };

/**
 * Fast Binary Encoding SwapsImportResponse field model
 */
class FieldModelSwapsImportResponse extends fbe.FieldModel {
  /**
   * Initialize field model with the given buffer and offset
   * @param {!fbe.ReadBuffer|!fbe.WriteBuffer} buffer Buffer
   * @param {!number} offset Offset
   * @constructor
   */
  constructor (buffer, offset) {
    super(buffer, offset)
    this._parent = new FieldModelConfigUpdateResponse(buffer, 4 + 4)
    this.GroupsUpdated = new fbe.FieldModelVector(new fbe.FieldModelString(buffer, this._parent.fbeOffset + this._parent.fbeBody - 4 - 4), buffer, this._parent.fbeOffset + this._parent.fbeBody - 4 - 4)
    this.SymbolsUpdated = new fbe.FieldModelVector(new fbe.FieldModelString(buffer, this.GroupsUpdated.fbeOffset + this.GroupsUpdated.fbeSize), buffer, this.GroupsUpdated.fbeOffset + this.GroupsUpdated.fbeSize)
  }

  /**
   * Get the ConfigUpdateResponse field model
   * @this {!FieldModelSwapsImportResponse}
   * @returns {!FieldModelConfigUpdateResponse} ConfigUpdateResponse field model
   */
  get parent () {
    return this._parent
  }

  /**
   * Get the field size
   * @this {!FieldModelSwapsImportResponse}
   * @returns {!number} Field size
   */
  get fbeSize () {
    return 4
  }

  /**
   * Get the field body size
   * @this {!FieldModelSwapsImportResponse}
   * @returns {!number} Field body size
   */
  get fbeBody () {
    return 4 + 4 + this.parent.fbeBody - 4 - 4 + this.GroupsUpdated.fbeSize + this.SymbolsUpdated.fbeSize
  }

  /**
   * Get the field extra size
   * @this {!FieldModelSwapsImportResponse}
   * @returns {!number} Field extra size
   */
  get fbeExtra () {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4) > this._buffer.size)) {
      return 0
    }

    this._buffer.shift(fbeStructOffset)

    let fbeResult = this.fbeBody + this.parent.fbeExtra + this.GroupsUpdated.fbeExtra + this.SymbolsUpdated.fbeExtra

    this._buffer.unshift(fbeStructOffset)

    return fbeResult
  }

  /**
   * Get the field type
   * @this {!FieldModelSwapsImportResponse}
   * @returns {!number} Field type
   */
  get fbeType () {
    return FieldModelSwapsImportResponse.fbeType
  }

  /**
   * Get the field type (static)
   * @this {!FieldModelSwapsImportResponse}
   * @returns {!number} Field type
   */
  static get fbeType () {
    return 6121
  }

  /**
   * Check if the struct value is valid
   * @this {!FieldModelSwapsImportResponse}
   * @param {!boolean} fbeVerifyType Verify model type flag, defaults is true
   * @returns {!boolean} Field model valid state
   */
  verify (fbeVerifyType = true) {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return true
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4 + 4) > this._buffer.size)) {
      return false
    }

    let fbeStructSize = this.readUInt32(fbeStructOffset)
    if (fbeStructSize < (4 + 4)) {
      return false
    }

    let fbeStructType = this.readUInt32(fbeStructOffset + 4)
    if (fbeVerifyType && (fbeStructType !== this.fbeType)) {
      return false
    }

    this._buffer.shift(fbeStructOffset)
    let fbeResult = this.verifyFields(fbeStructSize)
    this._buffer.unshift(fbeStructOffset)
    return fbeResult
  }

  /**
   * Check if the struct fields are valid
   * @this {!FieldModelSwapsImportResponse}
   * @param {!number} fbeStructSize FBE struct size
   * @returns {!boolean} Field model valid state
   */
  verifyFields (fbeStructSize) {
    let fbeCurrentSize = 4 + 4

    if ((fbeCurrentSize + this.parent.fbeBody - 4 - 4) > fbeStructSize) {
      return true
    }
    if (!this.parent.verifyFields(fbeStructSize)) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.parent.fbeBody - 4 - 4

    if ((fbeCurrentSize + this.GroupsUpdated.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.GroupsUpdated.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.GroupsUpdated.fbeSize

    if ((fbeCurrentSize + this.SymbolsUpdated.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.SymbolsUpdated.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.SymbolsUpdated.fbeSize

    return true
  }

  /**
   * Get the struct value (begin phase)
   * @this {!FieldModelSwapsImportResponse}
   * @returns {!number} Field model begin offset
   */
  getBegin () {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    console.assert((fbeStructOffset > 0) && ((this._buffer.offset + fbeStructOffset + 4 + 4) <= this._buffer.size), 'Model is broken!')
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4 + 4) > this._buffer.size)) {
      return 0
    }

    let fbeStructSize = this.readUInt32(fbeStructOffset)
    console.assert((fbeStructSize >= (4 + 4)), 'Model is broken!')
    if (fbeStructSize < (4 + 4)) {
      return 0
    }

    this._buffer.shift(fbeStructOffset)
    return fbeStructOffset
  }

  /**
   * Get the struct value (end phase)
   * @this {!FieldModelSwapsImportResponse}
   * @param {!number} fbeBegin Field model begin offset
   */
  getEnd (fbeBegin) {
    this._buffer.unshift(fbeBegin)
  }

  /**
   * Get the struct value
   * @this {!FieldModelSwapsImportResponse}
   * @param {!SwapsImportResponse} fbeValue Default value, defaults is new SwapsImportResponse()
   * @returns {!SwapsImportResponse} SwapsImportResponse value
   */
  get (fbeValue = new SwapsImportResponse()) {
    let fbeBegin = this.getBegin()
    if (fbeBegin === 0) {
      return fbeValue
    }

    let fbeStructSize = this.readUInt32(0)
    this.getFields(fbeValue, fbeStructSize)
    this.getEnd(fbeBegin)
    return fbeValue
  }

  /**
   * Get the struct fields values
   * @this {!FieldModelSwapsImportResponse}
   * @param {!SwapsImportResponse} fbeValue SwapsImportResponse value
   * @param {!number} fbeStructSize Struct size
   */
  getFields (fbeValue, fbeStructSize) {
    let fbeCurrentSize = 4 + 4

    if ((fbeCurrentSize + this.parent.fbeBody - 4 - 4) <= fbeStructSize) {
      this.parent.getFields(fbeValue, fbeStructSize)
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.parent.fbeBody - 4 - 4

    if ((fbeCurrentSize + this.GroupsUpdated.fbeSize) <= fbeStructSize) {
      this.GroupsUpdated.get(fbeValue.GroupsUpdated)
    } else {
      fbeValue.GroupsUpdated.length = 0
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.GroupsUpdated.fbeSize

    if ((fbeCurrentSize + this.SymbolsUpdated.fbeSize) <= fbeStructSize) {
      this.SymbolsUpdated.get(fbeValue.SymbolsUpdated)
    } else {
      fbeValue.SymbolsUpdated.length = 0
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.SymbolsUpdated.fbeSize
  }

  /**
   * Set the struct value (begin phase)
   * @this {!FieldModelSwapsImportResponse}
   * @returns {!number} Field model begin offset
   */
  setBegin () {
    console.assert(((this._buffer.offset + this.fbeOffset + this.fbeSize) <= this._buffer.size), 'Model is broken!')
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructSize = this.fbeBody
    let fbeStructOffset = this._buffer.allocate(fbeStructSize) - this._buffer.offset
    console.assert((fbeStructOffset > 0) && ((this._buffer.offset + fbeStructOffset + fbeStructSize) <= this._buffer.size), 'Model is broken!')
    if ((fbeStructOffset <= 0) || ((this._buffer.offset + fbeStructOffset + fbeStructSize) > this._buffer.size)) {
      return 0
    }

    this.writeUInt32(this.fbeOffset, fbeStructOffset)
    this.writeUInt32(fbeStructOffset, fbeStructSize)
    this.writeUInt32(fbeStructOffset + 4, this.fbeType)

    this._buffer.shift(fbeStructOffset)
    return fbeStructOffset
  }

  /**
   * Set the struct value (end phase)
   * @this {!FieldModelSwapsImportResponse}
   * @param {!number} fbeBegin Field model begin offset
   */
  setEnd (fbeBegin) {
    this._buffer.unshift(fbeBegin)
  }

  /**
   * Set the struct value
   * @this {!FieldModelSwapsImportResponse}
   * @param {!SwapsImportResponse} fbeValue SwapsImportResponse value
   */
  set (fbeValue) {
    let fbeBegin = this.setBegin()
    if (fbeBegin === 0) {
      return
    }

    this.setFields(fbeValue)
    this.setEnd(fbeBegin)
  }

  /**
   * Set the struct fields values
   * @this {!FieldModelSwapsImportResponse}
   * @param {SwapsImportResponse} fbeValue SwapsImportResponse value
   */
  setFields (fbeValue) {
    this.parent.setFields(fbeValue)
    this.GroupsUpdated.set(fbeValue.GroupsUpdated)
    this.SymbolsUpdated.set(fbeValue.SymbolsUpdated)
  }
}

export { FieldModelSwapsImportResponse };

/**
 * Fast Binary Encoding SwapsImportResponse model
 */
class SwapsImportResponseModel extends fbe.Model {
  /**
   * Initialize model with the given buffer
   * @param {!fbe.ReadBuffer|!fbe.WriteBuffer} buffer Read/Write buffer, defaults is new fbe.WriteBuffer()
   * @constructor
   */
  constructor (buffer = new fbe.WriteBuffer()) {
    super(buffer)
    this._model = new FieldModelSwapsImportResponse(this.buffer, 4)
  }

  /**
   * Get the SwapsImportResponse model
   * @this {!SwapsImportResponseModel}
   * @returns {!FieldModelSwapsImportResponse} model SwapsImportResponse model
   */
  get model () {
    return this._model
  }

  /**
   * Get the model size
   * @this {!SwapsImportResponseModel}
   * @returns {!number} Model size
   */
  get fbeSize () {
    return this.model.fbeSize + this.model.fbeExtra
  }

  /**
   * Get the model type
   * @this {!SwapsImportResponseModel}
   * @returns {!number} Model type
   */
  get fbeType () {
    return SwapsImportResponseModel.fbeType
  }

  /**
   * Get the model type (static)
   * @this {!SwapsImportResponseModel}
   * @returns {!number} Model type
   */
  static get fbeType () {
    return FieldModelSwapsImportResponse.fbeType
  }

  /**
   * Check if the struct value is valid
   * @this {!SwapsImportResponseModel}
   * @returns {!boolean} Model valid state
   */
  verify () {
    if ((this.buffer.offset + this.model.fbeOffset - 4) > this.buffer.size) {
      return false
    }

    let fbeFullSize = this.readUInt32(this.model.fbeOffset - 4)
    if (fbeFullSize < this.model.fbeSize) {
      return false
    }

    return this.model.verify()
  }

  /**
   * Create a new model (begin phase)
   * @this {!SwapsImportResponseModel}
   * @returns {!number} Model begin offset
   */
  createBegin () {
    return this.buffer.allocate(4 + this.model.fbeSize)
  }

  /**
   * Create a new model (end phase)
   * @this {!SwapsImportResponseModel}
   * @param {!number} fbeBegin Model begin offset
   */
  createEnd (fbeBegin) {
    let fbeEnd = this.buffer.size
    let fbeFullSize = fbeEnd - fbeBegin
    this.writeUInt32(this.model.fbeOffset - 4, fbeFullSize)
    return fbeFullSize
  }

  /**
   * Serialize the struct value
   * @this {!SwapsImportResponseModel}
   * @param {!SwapsImportResponse} value SwapsImportResponse value
   * @return {!number} Model begin offset
   */
  serialize (value) {
    let fbeBegin = this.createBegin()
    this.model.set(value)
    return this.createEnd(fbeBegin)
  }

  /**
   * Deserialize the struct value
   * @this {!SwapsImportResponseModel}
   * @param {!SwapsImportResponse} value SwapsImportResponse value, defaults is new SwapsImportResponse()
   * @return {!object} Deserialized SwapsImportResponse value and its size
   */
  deserialize (value = new SwapsImportResponse()) {
    if ((this.buffer.offset + this.model.fbeOffset - 4) > this.buffer.size) {
      return { value: new SwapsImportResponse(), size: 0 }
    }

    let fbeFullSize = this.readUInt32(this.model.fbeOffset - 4)
    console.assert((fbeFullSize >= this.model.fbeSize), 'Model is broken!')
    if (fbeFullSize < this.model.fbeSize) {
      return { value: new SwapsImportResponse(), size: 0 }
    }

    this.model.get(value)
    return { value: value, size: fbeFullSize }
  }

  /**
   * Move to the next struct value
   * @this {!SwapsImportResponseModel}
   * @param {!number} prev Previous SwapsImportResponse model size
   */
  next (prev) {
    this.model.fbeShift(prev)
  }
}

export { SwapsImportResponseModel };
